import * as XLSX from 'xlsx';

export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Get first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          raw: false, // Keep dates as strings
          defval: "", // Default value for empty cells
        });

        resolve(jsonData);
      } catch (error) {
        reject(new Error("Failed to parse Excel file: " + error.message));
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsArrayBuffer(file);
  });
};

export const normalizeColumnNames = (data) => {
  // Handle potential column name variations
  return data.map((row) => {
    const normalized = {};
    Object.keys(row).forEach((key) => {
      const normalizedKey = key
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "_");
      normalized[normalizedKey] = row[key];
    });
    return normalized;
  });
};
